import PaddleCheckoutButton from "@litonarefin/components/PaddleCheckoutButton/PaddleCheckoutButton";
// import { useSearchParams } from "next/navigation";
// import { useEffect } from "react";

const BundlePaddleCheckout = ({ attributes }) => {
  // const searchParams = useSearchParams();
  // const plan_id = searchParams.get("plan_id");

  /**
   * Auto click in new tab
   */
  // useEffect(() => {
  //   const triggerBtn = document.querySelector(
  //     `[data-plan-id="${attributes?.selectedVariationId}"]`
  //   );
  //   if (!triggerBtn) return;

  //   let timeoutId;
  //   if (plan_id === triggerBtn.getAttribute("data-plan-id")) {
  //     timeoutId = setTimeout(() => {
  //       triggerBtn.click();
  //     }, 100);
  //   }

  //   return () => clearTimeout(timeoutId);
  // }, [plan_id]);

  // Pass-through. `attributes.checkoutQuery` is encrypted upstream by the server
  // BlockRenderer — not here: this module is imported by BundlePricing, which is a
  // client component, and the AES key is server-only.
  return <PaddleCheckoutButton attributes={attributes} />;
};

export default BundlePaddleCheckout;
